<div class="features-page py-5">
  <div class="container">
    <section class="hero-card text-center mx-auto mb-5">
      <span class="eyebrow">Built for owners, captains, and fleet operators</span>
      <h1 class="display-5 fw-bold mt-3 mb-3">Everything your operation needs to look sharper, move faster, and stay under control.</h1>
      <p class="lead text-muted mb-0">
        {{ title }} is engineered for teams who are done tolerating scattered spreadsheets, forgotten maintenance, missing documents,
        and reactive decision making. It brings the operational rigor of a professional control room to every yacht, every trip, and every subscription tier.
      </p>
      <p class="text-muted mt-3 mb-0">
        Explore our <a routerLink="/yachtapp-solutions">yacht operations solutions</a> for owner and crew workflows,
        or see how <a routerLink="/smart-yacht-management">smart yacht management</a> connects maintenance, documents and voyage planning.
      </p>
    </section>

    <section class="row g-4 mb-5">
      <div class="col-lg-6" *ngFor="let pillar of pillars">
        <article class="info-card h-100">
          <div class="d-flex align-items-start gap-3 mb-3">
            <div class="icon-wrap">
              <i class="{{ pillar.icon }}"></i>
            </div>
            <div>
              <h3 class="h4 mb-2">{{ pillar.title }}</h3>
              <p class="text-muted mb-0">{{ pillar.description }}</p>
            </div>
          </div>
          <ul class="feature-bullets mb-0">
            <li *ngFor="let bullet of pillar.bullets">{{ bullet }}</li>
          </ul>
        </article>
      </div>
    </section>

    <section class="proof-strip mb-5">
      <div class="row g-3 text-center">
        <div class="col-md-4">
          <div class="proof-tile h-100">
            <h4>Replace friction with flow</h4>
            <p class="mb-0 text-muted">Standardize boats, worklogs, reminders, inventory, checklists, routes, and cruises inside one connected system.</p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="proof-tile h-100">
            <h4>Make risk visible earlier</h4>
            <p class="mb-0 text-muted">Surface overdue work, upcoming maintenance, expiring inventory, missing documents, and route context before they become expensive problems.</p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="proof-tile h-100">
            <h4>Scale with confidence</h4>
            <p class="mb-0 text-muted">Move from a single vessel to a structured fleet workflow without rebuilding your operating habits from scratch.</p>
          </div>
        </div>
      </div>
    </section>

    <section class="table-card mb-5">
      <div class="text-center mb-4">
        <span class="eyebrow">Feature comparison</span>
        <h2 class="h1 mt-2">Why serious operators upgrade to {{ title }}</h2>
        <p class="text-muted mb-0">
          The real difference is not one isolated tool. It is the compound effect of planning, maintenance, compliance, collaboration,
          and navigation working together in the same operating system.
        </p>
      </div>

      <div class="table-responsive">
        <table class="table table-bordered align-middle comparison-table">
          <thead class="table-light text-center">
            <tr>
              <th scope="col" class="text-start">Capability</th>
              <th scope="col">{{ title }}</th>
              <th scope="col">Spreadsheets</th>
              <th scope="col">Manual Logs</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of comparisonRows">
              <th scope="row">{{ row.label }}</th>
              <td class="text-center"><i [class]="iconClass(row.yachtapp) + ' fs-5'"></i></td>
              <td class="text-center"><i [class]="iconClass(row.spreadsheet) + ' fs-5'"></i></td>
              <td class="text-center"><i [class]="iconClass(row.manual) + ' fs-5'"></i></td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <section class="cta-card text-center mx-auto">
      <span class="eyebrow">Your operation is ready for more</span>
      <h2 class="mt-3 mb-3">Stop managing yachts like disconnected tasks. Start running them like a high-performing system.</h2>
      <p class="text-muted mb-4">
        Every extra day on spreadsheets is another day of hidden risk, slower follow-up, and lost operational clarity.
        Subscribe now and step into a platform built to make your team look faster, tighter, and unmistakably more professional.
      </p>
      <div class="d-flex flex-column flex-sm-row justify-content-center gap-3">
        <a routerLink="/register" class="btn btn-primary btn-lg px-4">Start your account</a>
        <a routerLink="/subscriptions" class="btn btn-outline-primary btn-lg px-4">Explore subscription plans</a>
      </div>
    </section>
  </div>
</div>
